// extracted by mini-css-extract-plugin
export var actions = "_ld-d";
export var benefitCard = "_ld-a";
export var benefitIcon = "_ld-b";
export var benefitLabel = "_ld-c";
export var benefits = "_ld-9";
export var bodyText = "_ld-8";
export var closeButton = "_ld-2";
export var content = "_ld-3";
export var eyebrow = "_ld-4";
export var heading = "_ld-5";
export var image = "_ld-f";
export var imagePanel = "_ld-e";
export var modal = "_ld-0";
export var shell = "_ld-1";
export var title = "_ld-6";
export var titleOffer = "_ld-7";